/* ==========================================================================
   Custom Product Landing Page — front-end behaviour
   - Hero    : variant selection (device-option cards) + thumbnail gallery
   - Carousel: "Backed by science" before/after slides
   - Tabs    : "What's included" / "Specifications"
   Self-contained: does not depend on the theme's product-info.js.
   ========================================================================== */
(function () {
  'use strict';

  /* ---- Hero --------------------------------------------------------------- */
  function initHero(hero) {
    var form = hero.querySelector('[data-lp-form]');
    var variantsTag = hero.querySelector('[data-lp-variants]');
    if (!form || !variantsTag) return;

    var variants;
    try {
      variants = JSON.parse(variantsTag.textContent);
    } catch (e) {
      return;
    }

    var idInput = form.querySelector('input[name="id"]');
    var submitBtn = form.querySelector('[type="submit"]');
    var radios = hero.querySelectorAll('[data-lp-variant-radio]');

    function update() {
      var checked = hero.querySelector('[data-lp-variant-radio]:checked');
      if (!checked) return;

      var variant = variants.find(function (v) {
        return String(v.id) === String(checked.value);
      });
      if (!variant) return;

      if (idInput) idInput.value = variant.id;

      if (submitBtn) {
        var label = submitBtn.querySelector('span');
        if (variant.available) {
          submitBtn.disabled = false;
          if (label) label.textContent = submitBtn.getAttribute('data-add') || 'Add to bag';
        } else {
          submitBtn.disabled = true;
          if (label) label.textContent = submitBtn.getAttribute('data-soldout') || 'Sold out';
        }
      }

      if (variant.id && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', update);
    });

    var slides = hero.querySelectorAll('[data-lp-slide]');
    var thumbs = hero.querySelectorAll('[data-lp-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = thumb.getAttribute('data-lp-thumb');
        slides.forEach(function (slide) {
          var active = slide.getAttribute('data-lp-slide') === idx;
          slide.classList.toggle('is-active', active);
          var vid = slide.querySelector('video');
          if (vid) {
            // keep the video looping/playing while visible, pause it when hidden
            if (active && typeof vid.play === 'function') { var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
            else if (typeof vid.pause === 'function') vid.pause();
          }
        });
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ---- Carousel ----------------------------------------------------------- */
  function initCarousel(root) {
    var track = root.querySelector('[data-lp-track]');
    if (!track) return;

    var slides = root.querySelectorAll('[data-lp-slide]');
    if (slides.length < 2) return;

    var prev = root.querySelector('[data-lp-prev]');
    var next = root.querySelector('[data-lp-next]');
    var counter = root.querySelector('[data-lp-counter]');
    var index = 0;

    function render() {
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === index);
      });
      if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        if (index > 0) { index--; render(); }
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        if (index < slides.length - 1) { index++; render(); }
      });
    }

    render();
  }

  /* ---- Video caption expand/collapse -------------------------------------- */
  function initCaptionToggle(caption) {
    var btn = caption.querySelector('[data-lp-caption-toggle]');
    var panel = caption.querySelector('[data-lp-caption-panel]');
    if (!btn || !panel) return;

    btn.addEventListener('click', function () {
      var expanded = caption.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (expanded) {
        panel.hidden = false;
      } else {
        panel.hidden = true;
      }
    });
  }

  /* ---- Tabs --------------------------------------------------------------- */
  function initTabs(root) {
    var tabs = root.querySelectorAll('[data-lp-tab]');
    var panels = root.querySelectorAll('[data-lp-tabpanel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = tab.getAttribute('data-lp-tab');
        tabs.forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-lp-tabpanel') === idx);
        });
      });
    });
  }

  /* ---- Init --------------------------------------------------------------- */
  function init() {
    document.querySelectorAll('[data-lp-hero]').forEach(initHero);
    document.querySelectorAll('[data-lp-carousel]').forEach(initCarousel);
    document.querySelectorAll('[data-lp-tabs]').forEach(initTabs);
    document.querySelectorAll('[data-lp-caption]').forEach(initCaptionToggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
